import Banner from "./Banner";

const CareerPage = () => {
  return (
    <>
      <Banner />
      <div className="d-flex justify-content-center">
        <h3
          class="gdlr-core-title-item-title gdlr-core-skin-title"
          style={{ margin: "100px 0" }}
        >
          No Opened Positions
        </h3>
      </div>
    </>
  );
};

export default CareerPage;
